/* Stage Zero: Make / Model / Year finder, "My Garage", fit badges, product form.
   Vehicle data comes from the theme setting "Vehicle list" (window.SZ.vehicles).
   A product fits a vehicle when it has the tag  fits-<make>-<model>-<year>
   e.g. fits-bmw-m3-m4-2018, fits-audi-a3-s3-2019                           */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');
  var SZ = window.SZ || {};
  var KEY = 'sz-garage';
  var vehicles = (SZ.vehicles || []).filter(function (v) { return v && v.make && v.model && v.from; });

  function slug(s) {
    return String(s).toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function vehicleTag(v) { return 'fits-' + slug(v.make + ' ' + v.model + ' ' + v.year); }
  function vehicleName(v) { return v.year + ' ' + v.make + ' ' + v.model; }

  function load() {
    var v = null;
    try { v = JSON.parse(localStorage.getItem(KEY)); } catch (e) { v = null; }
    if (!v || !v.make) return null;
    // Forget a saved car the store no longer carries (e.g. left over from an old vehicle list).
    var y = parseInt(v.year, 10);
    var ok = vehicles.some(function (c) { return c.make === v.make && c.model === v.model && y >= c.from && y <= c.to; });
    if (!ok) { clear(); return null; }
    return v;
  }
  function save(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function clear() { try { localStorage.removeItem(KEY); } catch (e) {} }

  function makes() {
    var seen = {}, out = [];
    vehicles.forEach(function (v) { if (!seen[v.make]) { seen[v.make] = 1; out.push(v.make); } });
    return out.sort();
  }
  function models(make) {
    return vehicles.filter(function (v) { return v.make === make; })
      .map(function (v) { return v.model; }).sort();
  }
  function years(make, model) {
    var v = vehicles.find(function (x) { return x.make === make && x.model === model; });
    if (!v) return [];
    var out = [], to = v.to || v.from;
    for (var y = to; y >= v.from; y--) out.push(y);
    return out;
  }
  function fill(select, placeholder, values) {
    select.innerHTML = '';
    var o = document.createElement('option');
    o.value = ''; o.textContent = placeholder; select.appendChild(o);
    values.forEach(function (val) {
      var opt = document.createElement('option');
      opt.value = val; opt.textContent = val; select.appendChild(opt);
    });
    select.disabled = values.length === 0;
  }

  /* ---------------- Finder widgets ---------------- */
  function initFinder(root) {
    var mk = root.querySelector('[data-ymm-make]');
    var md = root.querySelector('[data-ymm-model]');
    var yr = root.querySelector('[data-ymm-year]');
    var go = root.querySelector('[data-ymm-go]');
    var clr = root.querySelector('[data-ymm-clear]');
    if (!mk || !md || !yr) return;

    fill(mk, 'Select', makes());
    fill(md, 'Select', []);
    fill(yr, 'Select', []);

    function sync() { if (go) go.disabled = !(mk.value && md.value && yr.value); }

    mk.addEventListener('change', function () {
      fill(md, 'Select', mk.value ? models(mk.value) : []);
      fill(yr, 'Select', []);
      sync();
    });
    md.addEventListener('change', function () {
      fill(yr, 'Select', md.value ? years(mk.value, md.value) : []);
      sync();
    });
    yr.addEventListener('change', function () {
      sync();
      if (root.hasAttribute('data-ymm-auto') && yr.value) submit();
    });

    function submit() {
      if (!(mk.value && md.value && yr.value)) return;
      var v = { make: mk.value, model: md.value, year: parseInt(yr.value, 10) };
      save(v);
      window.location.href = (SZ.allUrl || '/collections/all') + '/' + vehicleTag(v);
    }
    if (go) go.addEventListener('click', function (e) { e.preventDefault(); submit(); });
    if (clr) clr.addEventListener('click', function (e) {
      e.preventDefault(); clear(); window.location.href = SZ.allUrl || '/collections/all';
    });

    // Pre-select the saved vehicle
    var saved = load();
    if (saved) {
      mk.value = saved.make; fill(md, 'Select', models(saved.make));
      md.value = saved.model; fill(yr, 'Select', years(saved.make, saved.model));
      yr.value = String(saved.year);
      if (clr) clr.hidden = false;
    }
    sync();
  }

  /* ---------------- Header garage pill ---------------- */
  function renderGarage() {
    var v = load();
    document.querySelectorAll('[data-garage]').forEach(function (el) {
      var label = el.querySelector('[data-garage-label]');
      if (v) {
        el.classList.add('has-vehicle');
        if (label) label.textContent = vehicleName(v);
      } else {
        el.classList.remove('has-vehicle');
        if (label) label.textContent = 'Select your vehicle';
      }
    });
    document.querySelectorAll('[data-garage-link]').forEach(function (a) {
      if (v) a.href = (SZ.allUrl || '/collections/all') + '/' + vehicleTag(v);
    });
  }

  /* ---------------- Fit badges ---------------- */
  var ICON_YES = '<svg class="fit__icon" viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="currentColor" opacity=".18"/><path d="M4.5 8.2l2.3 2.3 4.7-5" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';
  var ICON_NO = '<svg class="fit__icon" viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="currentColor" opacity=".18"/><path d="M5.2 5.2l5.6 5.6M10.8 5.2l-5.6 5.6" stroke="currentColor" stroke-width="1.8"/></svg>';
  var ICON_Q = '<svg class="fit__icon" viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="7.2" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M8 4.5v4.5M8 11v.6" stroke="currentColor" stroke-width="1.6"/></svg>';

  function renderFit() {
    var v = load();
    document.querySelectorAll('[data-fit]').forEach(function (el) {
      var tags = [];
      try { tags = JSON.parse(el.getAttribute('data-tags') || '[]'); } catch (e) {}
      var hasFitment = tags.some(function (t) { return /^fits-/i.test(t); });
      var large = el.classList.contains('fit--lg');
      el.classList.remove('is-yes', 'is-no', 'is-unknown');
      if (!hasFitment) { el.innerHTML = ''; return; }
      if (!v) {
        if (large) {
          el.classList.add('is-unknown');
          el.innerHTML = ICON_Q + '<span>Select your vehicle to confirm fitment.</span><button type="button" data-open-garage>Select vehicle</button>';
        } else { el.innerHTML = ''; }
        return;
      }
      var tag = vehicleTag(v);
      var yes = tags.some(function (t) { return slug(t) === tag; });
      el.classList.add(yes ? 'is-yes' : 'is-no');
      el.innerHTML = (yes ? ICON_YES : ICON_NO) + '<span>' + (yes ? 'Fits your ' : "Doesn't fit your ") + vehicleName(v) + '</span>' +
        (large ? '<button type="button" data-open-garage>Change</button>' : '');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-garage]');
    if (!t) return;
    e.preventDefault();
    var g = document.querySelector('details[data-garage]');
    if (g) { g.open = true; window.scrollTo({ top: 0, behavior: 'smooth' }); var s = g.querySelector('select'); if (s) setTimeout(function () { s.focus(); }, 250); }
  });

  // Close garage dropdown when clicking outside
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[data-garage][open]').forEach(function (d) {
      if (!d.contains(e.target) && !e.target.closest('[data-open-garage]')) d.open = false;
    });
  });

  /* ---------------- Product form: variants, gallery, qty ---------------- */
  function money(cents) {
    var fmt = SZ.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var noDec = String(Math.round(cents / 100));
    var withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withComma)
      .replace(/<[^>]*>/g, '');
  }

  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product; try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = root.querySelector('[name="id"]');
    var btn = root.querySelector('[data-add-btn]');
    var priceNow = root.querySelectorAll('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var priceSave = root.querySelector('[data-price-save]');

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-group]'), function (g) {
        var c = g.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function update() {
      var opts = selected();
      root.querySelectorAll('[data-option-group]').forEach(function (g, i) {
        var lbl = g.querySelector('[data-option-value]'); if (lbl) lbl.textContent = opts[i] || '';
      });
      var v = product.variants.find(function (x) {
        return x.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; } return; }
      if (idInput) idInput.value = v.id;
      priceNow.forEach(function (el) { el.textContent = money(v.price); });
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.textContent = money(v.compare_at_price); priceWas.hidden = false;
          if (priceSave) { priceSave.textContent = 'Save ' + money(v.compare_at_price - v.price); priceSave.hidden = false; }
        } else { priceWas.hidden = true; if (priceSave) priceSave.hidden = true; }
      }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    root.querySelectorAll('[data-option-group] input').forEach(function (inp) { inp.addEventListener('change', update); });
    if (root.querySelector('[data-option-group]')) update();

    // gallery thumbs
    var main = root.querySelector('[data-gallery-main]');
    root.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (main) { main.src = b.getAttribute('data-src'); main.srcset = ''; }
        root.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });

    // sticky add-to-cart on mobile
    var sticky = document.querySelector('[data-sticky-atc]');
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && window.innerWidth < 860);
      }).observe(btn);
      var sbtn = sticky.querySelector('button');
      if (sbtn) sbtn.addEventListener('click', function () { if (form) form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
  }

  /* ---------------- Quantity steppers ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    if (!input) return;
    var n = parseInt(input.value || '1', 10) + (b.getAttribute('data-qty') === 'up' ? 1 : -1);
    var min = parseInt(input.getAttribute('min') || '1', 10);
    input.value = Math.max(min, n);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) e.target.form && e.target.form.submit();
  });

  /* ---------------- Reveal on scroll ---------------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Collection page: remember vehicle from URL ---------------- */
  function syncFromUrl() {
    var m = window.location.pathname.match(/\/fits-([a-z0-9-]+?)-(\d{4})(?:\+|\/|$)/i);
    if (!m) return;
    var year = parseInt(m[2], 10);
    var v = vehicles.find(function (x) { return slug(x.make + ' ' + x.model) === m[1].toLowerCase(); });
    if (v && year >= v.from && year <= (v.to || v.from)) save({ make: v.make, model: v.model, year: year });
  }

  /* ---------------- "More for this car" (loads the car's parts via the Section Rendering API) ---------------- */
  function initRelated() {
    document.querySelectorAll('[data-related]').forEach(function (box) {
      var url = box.getAttribute('data-related');
      var skip = box.getAttribute('data-skip');
      var max = parseInt(box.getAttribute('data-max') || '4', 10);
      var grid = box.querySelector('[data-related-target]');
      if (!url || !grid || !window.fetch) return;
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=related-cards')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var cards = Array.prototype.filter.call(tmp.querySelectorAll('[data-handle]'), function (c) {
            return c.getAttribute('data-handle') !== skip;
          }).slice(0, max);
          if (!cards.length) return;
          cards.forEach(function (c) { c.classList.add('is-in'); grid.appendChild(c); });
          box.hidden = false;
          renderFit();
        })
        .catch(function () {});
    });
  }


  /* ---------------- Build your kit (product page) ---------------- */
  function initKit() {
    var box = document.querySelector('[data-kit]');
    if (!box || !window.fetch || !window.DOMParser) return;
    var root = document.querySelector('[data-product]');
    var pjson = root && root.querySelector('[data-product-json]');
    var form = root && root.querySelector('form[action*="/cart/add"]');
    if (!pjson || !form) return;
    var product; try { product = JSON.parse(pjson.textContent); } catch (e) { return; }
    var t2 = parseFloat(box.getAttribute('data-t2')) || 0, t3 = parseFloat(box.getAttribute('data-t3')) || 0, t4 = parseFloat(box.getAttribute('data-t4')) || t3;
    var fmt = box.getAttribute('data-money') || '${{amount}}';
    var list = box.querySelector('[data-kit-list]');
    var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; };
    function money(c) {
      var n = (c / 100);
      var withDec = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var noDec = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec).replace(/\{\{\s*amount\s*\}\}/, withDec).replace(/\{\{\s*[a-z_]+\s*\}\}/, withDec);
    }
    function currentVariant() {
      var input = form.querySelector('[name="id"]');
      var id = input ? parseInt(input.value, 10) : 0;
      return product.variants.find(function (v) { return v.id === id; }) || product.variants[0];
    }
    function renderCurrent() {
      var v = currentVariant();
      var row = list.querySelector('[data-kit-current]');
      if (!row) return;
      row.querySelector('[data-kit-vtitle]').textContent = product.variants.length > 1 ? v.title : '';
      row.setAttribute('data-price', v.price);
      row.setAttribute('data-id', v.id);
      row.querySelector('[data-kit-price]').textContent = money(v.price);
      update();
    }
    function update() {
      var rows = list.querySelectorAll('.kit__item');
      var n = 0, sum = 0;
      rows.forEach(function (r) {
        var on = r.hasAttribute('data-kit-current') || r.querySelector('input[type=checkbox]').checked;
        r.classList.toggle('is-on', on);
        if (on) { n++; sum += parseInt(r.getAttribute('data-price'), 10) || 0; }
      });
      var pct = n >= 4 ? t4 : (n === 3 ? t3 : (n === 2 ? t2 : 0));
      var total = Math.round(sum * (100 - pct) / 100);
      box.querySelector('[data-kit-total]').textContent = money(total);
      var was = box.querySelector('[data-kit-was]');
      was.textContent = pct ? money(sum) : '';
      var msg = box.querySelector('[data-kit-msg]');
      if (n <= 1) msg.textContent = 'Add 1 more part to save ' + t2 + '%.';
      else if (n === 2) msg.textContent = 'You save ' + t2 + '%. Add 1 more part to save ' + t3 + '%.';
      else if (n === 3 && t4 > t3) msg.textContent = 'You save ' + t3 + '%. Add 1 more part to save ' + t4 + '%.';
      else msg.textContent = 'You save ' + pct + '% (' + money(sum - total) + ').';
      var btn = box.querySelector('[data-kit-add]');
      btn.textContent = n > 1 ? 'Add ' + n + ' parts to cart' : 'Add to cart';
    }
    function row(item, isCurrent) {
      var vs = item.variants.filter(function (v) { return v.available; });
      var v = isCurrent ? currentVariant() : vs[0];
      var li = document.createElement('li');
      li.className = 'kit__item';
      li.setAttribute('data-price', v.price);
      li.setAttribute('data-id', v.id);
      if (isCurrent) li.setAttribute('data-kit-current', '');
      var img = item.image ? '<img src="' + esc(item.image) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="kit__noimg"></span>';
      var picker = '';
      if (!isCurrent && vs.length > 1) {
        picker = '<select class="kit__select" aria-label="Choose an option for ' + esc(item.title) + '">' + vs.map(function (x) {
          return '<option value="' + x.id + '" data-price="' + x.price + '">' + esc(x.title) + '</option>';
        }).join('') + '</select>';
      }
      li.innerHTML =
        '<label class="kit__check">' + (isCurrent ? '<input type="checkbox" checked disabled>' : '<input type="checkbox">') + '</label>' +
        '<div class="kit__img">' + img + '</div>' +
        '<div class="kit__info"><span class="kit__label">' + esc(isCurrent ? 'This part' : item.label) + '</span>' +
        (isCurrent ? '<span class="kit__name">' + esc(item.title) + '</span><span class="kit__vt" data-kit-vtitle></span>'
                   : '<a class="kit__name" href="' + esc(item.url) + '">' + esc(item.title) + '</a>' + picker) +
        '</div><span class="kit__price" data-kit-price>' + money(v.price) + '</span>';
      var sel = li.querySelector('select');
      if (sel) sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex];
        li.setAttribute('data-id', o.value); li.setAttribute('data-price', o.getAttribute('data-price'));
        li.querySelector('[data-kit-price]').textContent = money(parseInt(o.getAttribute('data-price'), 10));
        var cb = li.querySelector('input[type=checkbox]'); if (!cb.checked) cb.checked = true;
        update();
      });
      var cb = li.querySelector('input[type=checkbox]');
      if (!isCurrent) cb.addEventListener('change', update);
      li.addEventListener('click', function (e) {
        if (isCurrent || e.target.closest('a, select, input, label')) return;
        cb.checked = !cb.checked; update();
      });
      return li;
    }
    var src = box.getAttribute('data-src');
    fetch(src + (src.indexOf('?') > -1 ? '&' : '?') + 'section_id=kit-items')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-kit-json]');
        var items = []; try { items = JSON.parse(el ? el.textContent : '[]'); } catch (e) {}
        var current = box.getAttribute('data-current');
        var others = items.filter(function (i) { return i.handle !== current && i.variants.some(function (v) { return v.available; }); });
        if (!others.length) return;
        list.appendChild(row({ title: product.title, variants: product.variants.map(function (v) { return { id: v.id, title: v.title, price: v.price, available: true }; }) }, true));
        others.forEach(function (i) { list.appendChild(row(i, false)); });
        box.hidden = false;
        renderCurrent();
        form.addEventListener('change', function () { setTimeout(renderCurrent, 0); });
      })
      .catch(function () {});
    box.querySelector('[data-kit-add]').addEventListener('click', function () {
      var btn = this;
      var items = [];
      list.querySelectorAll('.kit__item').forEach(function (r) {
        var on = r.hasAttribute('data-kit-current') || r.querySelector('input[type=checkbox]').checked;
        if (on) items.push({ id: parseInt(r.getAttribute('data-id'), 10), quantity: 1 });
      });
      if (!items.length) return;
      btn.disabled = true; btn.textContent = 'Adding...';
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      }).catch(function () {
        btn.disabled = false; update();
        var msg = box.querySelector('[data-kit-msg]');
        msg.textContent = 'Something went wrong. Please try again, or add the parts one at a time.';
      });
    });
  }

  function init() {
    syncFromUrl();
    document.querySelectorAll('[data-ymm]').forEach(initFinder);
    document.querySelectorAll('[data-product]').forEach(initProduct);
    renderGarage();
    renderFit();
    initReveal();
    initRelated();
    initKit();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
